import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {hotelReviewActions, paymentModuleOpenSelector} from '@ibibo/hotels-review-reducer';

import * as S from './EarlyCheckinBlock.styles';

import EarlyCheckModalContent from '../EarlyCheckInModal/EarlyCheckInModal';

import Modal, {useModal} from '../../../../../shared/components/Modal';

const EarlyCheckinBlock: React.FC<{
  addOnList: Array<object>;
  earlycheckin: boolean;
  roomType: string;
}> = ({addOnList, earlycheckin, roomType}) => {
  const dispatch = useDispatch();
  const {isModalOpen, openModal, closeModal} = useModal();
  const payModuleOpen = useSelector(paymentModuleOpenSelector);

  const changeEarlyCheckinStatus = useCallback(
    status => {
      return dispatch(hotelReviewActions.updateEarlyCheckInStatus(status));
    },
    [dispatch],
  );
  return (
    <S.EarlyCheckinBlockOuter>
      <S.EarlyCheckinHeader>Early Check-in</S.EarlyCheckinHeader>

      <S.BookEarlyOuterWrap>
        <S.BookEarlyTextWrap>
          Reaching early? Book an early check-in addon with us
        </S.BookEarlyTextWrap>
        {(!!earlycheckin && (
          <S.AddEarlyWrap
            onClick={() => {
              changeEarlyCheckinStatus(false);
              if (payModuleOpen) dispatch(hotelReviewActions.resetPaymentsData());
            }}
          >
            Remove Early Check-in
          </S.AddEarlyWrap>
        )) || <S.AddEarlyWrap onClick={openModal}>Add Early Check-in</S.AddEarlyWrap>}
      </S.BookEarlyOuterWrap>
      <Modal isOpen={isModalOpen} closeModal={closeModal}>
        <EarlyCheckModalContent
          {...addOnList[0]}
          addCheckin={() => {
            if (payModuleOpen) dispatch(hotelReviewActions.resetPaymentsData());
            changeEarlyCheckinStatus(true);
            closeModal();
          }}
          roomType={roomType}
        />
      </Modal>
    </S.EarlyCheckinBlockOuter>
  );
};

export default EarlyCheckinBlock;
